/* eslint-disable class-methods-use-this */
const { deliveryTypes: DeliveryType } = require('pando-constants');
const { freightUnit } = require('../../constants/payments');
const { isEmpty, maxBy } = require('lodash');
const Helper = require('./utils/helper');

class FixedCharge {
  fixedCharges(data) {
    let fixedCharge = 0;
    const deliveryType = data.deliveryType;
    const freightContracts = data.freightCharges;
    // added filter since secondary consignees will not have gate id
    const gateIds = [...new Set(freightContracts.filter(contract => contract.sourceGateId)
      .map(contract => contract.sourceGateId.toString()))];

    const contractCharges = Helper.getContractCharges(data, gateIds,
      freightContracts, 'fixedRate');
    if (contractCharges.length) {
      fixedCharge = (deliveryType === DeliveryType.PTL) ? Math.max(...contractCharges) :
        contractCharges.reduce((acc, value) => acc + value, 0);
    }
    return fixedCharge;
  }

  computeFixedChargeBasedOnDeliveryType(data) {
    let fixedCharge = 0;
    if (data.deliveryType === DeliveryType.PTL) {
      fixedCharge = this.fixedCharges(data);
    } else {
      const freightContracts = !isEmpty(data.freightCharges) ? data.freightCharges : [];
      if (freightContracts.length) {
        if (freightContracts[0].freightUnit === freightUnit.per_trip) { // Assuming that the freightUnit will be uniform across charges in real-time
          const freightCharges = freightContracts.map(charge => ({ freightCharge: charge.freightCharge, fixedRate: charge.fixedRate || 0 }));
          const maxChargeEntry = maxBy(freightCharges, 'freightCharge');
          const multipleMaxEntries = freightCharges.filter(entry => entry.freightCharge === maxChargeEntry.freightCharge);
          if (multipleMaxEntries.length === 1) {
            fixedCharge = maxChargeEntry.fixedRate || 0;
          } else {
            fixedCharge = maxBy(multipleMaxEntries, 'fixedRate').fixedRate || 0;
          }
        } else {
          // added filter since secondary consignees will not have gate id
          const gateIds = [...new Set(freightContracts.filter(contract => contract.sourceGateId)
            .map(contract => contract.sourceGateId.toString()))];
          const contractCharges = Helper.getContractCharges(data, gateIds,
            freightContracts, 'fixedRate');
          fixedCharge = contractCharges.reduce((acc, value) => acc + value, 0);
        }
      }
    }
    return fixedCharge;
  }
}

module.exports = FixedCharge;
